import header from './inc/header';
import mobileMenu from './inc/menu-mobile';
import desktopMenu from './inc/menu-desktop';

import './frontend.scss';

(function () {
	const init = () => {
		header();
		mobileMenu();
		desktopMenu();
	};

	document.addEventListener('DOMContentLoaded', () => {
		init();
	});
})();
